export default __webpack_public_path__ + "olm.4d5f9da.wasm";